<script>

export default {
    name: 'Badge',
    props: {
        title: {
            type: String,
            required: true
        }
    }
};
</script>

<template>
    <div id="sfBadge">
        <span>{{title}}</span>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
#sfBadge {
    border-radius: 11px;
    background-color: #F59C00;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 22px;
    span {
        color: #F9F9F9;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 14px;
        padding: 4px 8px;
        display: inline-block;
    }
}
</style>